var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1373 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.4,
    filter: "url(#filter0_f_4015_9669)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M527.93 20.9816C605.798 -38.2508 654.492 -20.1746 669.106 -3.7325C698.153 28.4503 769.714 30.7888 795.006 -9.34113C820.298 -49.471 841.575 -117.234 792.745 -160.179C743.915 -203.123 667.889 -181.53 542.998 -162.915C418.108 -144.3 412.33 -187.343 341.403 -183.771C270.476 -180.199 202.044 -22.3703 266.636 27.2778C331.229 76.9258 430.594 95.022 527.93 20.9816Z",
    fill: "url(#paint0_linear_4015_9669)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M527.93 20.9816C605.798 -38.2508 654.492 -20.1746 669.106 -3.7325C698.153 28.4503 769.714 30.7888 795.006 -9.34113C820.298 -49.471 841.575 -117.234 792.745 -160.179C743.915 -203.123 667.889 -181.53 542.998 -162.915C418.108 -144.3 412.33 -187.343 341.403 -183.771C270.476 -180.199 202.044 -22.3703 266.636 27.2778C331.229 76.9258 430.594 95.022 527.93 20.9816Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4015_9669",
    x: -9.72266,
    y: -435.622,
    width: 1082.36,
    height: 756.716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_4015_9669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4015_9669",
    x1: 303.446,
    y1: 92.7791,
    x2: 435.599,
    y2: -245.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E42DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#5BB099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336268,
    stopColor: "#67D2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632216,
    stopColor: "#3D78D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81533,
    stopColor: "#212477"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg2);
export default __webpack_public_path__ + "static/media/login-bg-2.9ff1197e1cc60304aaa095b5c899a037.svg";
export { ForwardRef as ReactComponent };